import React from 'react';
import Cookies from 'js-cookie'; // Import für das Handling von Cookies
import api from '../api/axios';

const NavBarTopMenu = () => {

    // Funktion zum Ausloggen und Seite neu laden
    const logoutAndRedirect = async () => {
        try {
            // Schritt 1: Anfrage an die Logout-API über deine API-Verwaltung

            await api.get('/api/v1/logout');

            // Schritt 2: Access Token aus den Cookies löschen
            Cookies.remove('accessToken');

            // Schritt 3: Erfolgreich ausgeloggt, Seite neu laden
            window.location.reload();

        } catch (error) {
            console.error('Fehler beim Abmelden:', error);
            Cookies.remove('accessToken');
            window.location.reload();
        }
    };

    return (
        <div
            className='absolute top-14 right-0 bg-white border border-color-1 shadow-lg rounded-md py-2 w-48 z-10 font-color-4'>
            <div className='cursor-pointer px-4 py-2 hover:bg-gray-100' onClick={logoutAndRedirect}>
                Abmelden
            </div>
        </div>
    );
};

export default NavBarTopMenu;
